<template>
  <div>
    <q-dialog v-model="valor">
      <q-card
        class="text-brand-5 text-weight-bold"
        style="height: 500px; max-width: 900px; width: 900px"
      >
        <q-card-section>
          <div class="text-h6">{{ titulo }}</div>
        </q-card-section>
        <q-separator />

        <q-card-section class="row">
          <div class="row" v-if="aplicacaoExecutando">
            <SelecaoDeDedo
              draggable
              @dedo="receberDedo"
              :limparDados="removerDedo"
              :dedosSelecionados="dedosSelecionados"
              :tipoBiometria="'cadastro'"
              v-if="!biometria && tipoBiometria == 'cadastro'"
            />
            <img v-show="biometria" src="" id="image" alt="" />
            <div class="col q-ml-lg" style="height: 300px">
              <div class="row col-12" v-if="!biometria">
                <div class="row col-12 justify-center">
                  <p class="text-h6" v-if="tipoBiometria == 'verificacao'">
                    {{ mensagem }}
                  </p>
                  <p v-else>{{ mensagem }}</p>
                </div>
                <div class="row col-12 q-mt-lg justify-center">
                  <q-circular-progress
                    v-if="loading"
                    indeterminate
                    rounded
                    size="70px"
                    color="primary"
                    class="q-mt-xl"
                  />
                </div>
              </div>
              <SelecaoDeDedo
                draggable
                @dedo="receberDedo"
                :limparDados="removerDedo"
                :dedosSelecionados="dedosSelecionados"
                :tipoBiometria="'verificacao'"
                v-if="!biometria && tipoBiometria == 'verificacao' && !loading"
              />
            </div>
          </div>
          <div v-else class="row col-12" style="height: 300px">
            <div class="row col-12">
              <q-icon
                class="row justify-center col-12"
                size="70px"
                name="error_outline"
              />
              <div class="row col-12 justify-center">
                <span
                  style="text-align: center"
                  class="text-h6 q-mt-sm"
                  v-html="mensagemErro"
                ></span>
                <a
                  target="blank"
                  style="cursor: pointer"
                  href="https://multpex.movidesk.com/kb/article/364416/configuracao-leitor-biometrico-web"
                  ><q-icon size="50px" name="book" color="brand-1"
                /></a>
              </div>
            </div>
          </div>
        </q-card-section>

        <q-separator />
        <q-card-actions align="right" class="q-mt-lg">
          <div v-if="aplicacaoExecutando" class="row col justify-start q-ml-md">
            <div>
              <div class="row items-center">
                <div
                  style="
                    background-color: green;
                    width: 12px;
                    height: 12px;
                    border-radius: 3px;
                  "
                ></div>
                <span class="q-ml-xs">Dedos Cadastrados</span>
              </div>
              <div v-if="tipoBiometria == 'cadastro'" class="row items-center">
                <div
                  style="
                    background-color: yellow;
                    width: 13px;
                    height: 13px;
                    border-radius: 3px;
                  "
                ></div>
                <span class="q-ml-xs">Dedo Selecionado</span>
              </div>
            </div>
          </div>
          <q-btn
            icon="close"
            label="Fechar"
            color="negative"
            no-caps
            v-close-popup
          />
          <div
            class="q-gutter-x-sm q-ml-xs"
            v-if="tipoBiometria == 'verificacao'"
          >
            <q-btn
              v-if="base64Images.length > 0"
              icon="refresh"
              label="Refazer"
              color="primary"
              no-caps
              @click="refazer()"
            />
            <q-btn
              v-if="base64Images.length == 0 && aplicacaoExecutando"
              :disable="biometria"
              icon="fingerprint"
              label="Coletar Biometria"
              color="positive"
              no-caps
              @click="coletarBiometria()"
            />
          </div>
          <div class="q-gutter-x-sm q-ml-xs" v-if="tipoBiometria == 'cadastro'">
            <q-btn
              v-if="base64Images.length > 0"
              icon="refresh"
              label="Refazer"
              color="primary"
              no-caps
              :disable="disable"
              @click="refazer()"
            />
            <q-btn
              v-if="base64Images.length > 0"
              icon="fingerprint"
              label="Salvar Biometria"
              color="positive"
              no-caps
              @click="cadastrarBiometria()"
            />
          </div>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script setup>
import { useQuasar } from "quasar";
import { ref, watch, defineProps, defineEmits } from "vue";
import { useStore } from "vuex";

import SelecaoDeDedo from "../components/SelecaoDeDedoTeste.vue";

const store = useStore();
const quasar = useQuasar();
const emits = defineEmits([
  "atualizarBiometrias",
  "negativePrint",
  "resultadoVerificacao",
]);
const props = defineProps({
  modal: { type: Boolean },
  titulo: {
    type: String,
  },
  tipoBiometria: {
    type: String,
  },
  userId: {},
});

const valor = ref(false);
const versaoRegex = /^1\.(\d+)\.(\d+)$/;
const aplicacaoExecutando = ref(false);
const mensagemErro = ref("");
const loading = ref(false);
const disable = ref(false);
const negativePrint = ref("");
const biometria = ref(false);
const base64Images = ref([]);
const mensagem = ref("");
let dedoSelecionado = ref(null);
const removerDedo = ref(0);

const getVersion = async () => {
  try {
    const response = await store.dispatch("biometria/getVersion");
    if (validarVersao(response.data.versao)) {
      aplicacaoExecutando.value = true;
      receberDedosCadastrados();
      return;
    }
    mensagemErro.value =
      "Versão desatualizada, por favor faça o download da nova versão.";
  } catch (error) {
    mensagemErro.value =
      "Aplicação desktop parada, favor iniciar antes de começar as rotinas de cadastro/verificação. Se não tiver a aplicação instalada, favor consultar procedimento para dowload";
  }
};

const coletarBiometria = async () => {
  loading.value = true;
  disable.value = true;
  try {
    let response = await store.dispatch("biometria/getIdentification");
    if (!response.data.sucesso) {
      quasar.notify({
        message: response.data.mensagemErro,
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      return;
    }
    let fingerPrint = response.data.imagemDigital;
    negativePrint.value = response.data.imagemDigitalNegativa;
    if (fingerPrint) {
      let image = document.getElementById("image");
      biometria.value = true;
      image.src = "data:image/png;base64, " + negativePrint.value;
      base64Images.value.push(fingerPrint);
    }
    loading.value = false;
    disable.value = false;
    if (props.tipoBiometria == "verificacao") {
      verificarBiometria();
      return;
    }
    mensagem.value = "Clique em Salvar Biometria para completar o cadastro";
  } catch (error) {
    quasar.notify({
      message: error.response.data.mensagemErro,
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    loading.value = false;
    disable.value = false;
  }
};

const verificarBiometria = async () => {
  try {
    const response = await store.dispatch("biometria/verificarBiometriaTeste", {
      funcionarioId: props.userId,
      imagem: base64Images.value[0],
      largura: 320,
      altura: 480,
      resolucao: 500,
    });
    emits("negativePrint", negativePrint.value);
    if (
      response.data?.resposta?.funcionarioDedo.funcionarioId == props.userId
    ) {
      quasar.notify({
        message: "Biometria verificada com sucesso",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      emits("resultadoVerificacao", true);
      valor.value = false;
      return;
    }
    quasar.notify({
      message:
        "A biometria verificada não coincide com a do solicitante, faça novamente o processo de verificação.",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    emits("resultadoVerificacao", false);
    refazer();
  } catch (error) {
    console.log(error);
    quasar.notify({
      message: "Erro ao verificar biometria",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const cadastrarBiometria = async () => {
  loading.value = true;
  try {
    await store.dispatch("biometria/cadastrarBiometriaTeste", {
      funcionarioId: props.userId,
      imagem: base64Images.value,
      indiceDedo: dedoSelecionado.value?.value,
      largura: 320,
      altura: 480,
      resolucao: 500,
    });
    loading.value = false;
    quasar.notify({
      message: "Biometria cadastrada com sucesso",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    emits("atualizarBiometrias");
    refazer();
  } catch (error) {
    console.log(error);
    loading.value = false;
    quasar.notify({
      message: "Erro ao cadastrar biometria",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const receberDedosCadastrados = async () => {
  try {
    const response = await store.dispatch(
      "biometria/verificarBiometriaDedosCadastrados",
      {
        funcionarioId: props.userId,
      }
    );
    console.log(response);
  } catch (error) {
    console.log(error);
  }
};

const refazer = () => {
  removerDedo.value++;
  let image = document.getElementById("image");
  image.src = "";
  mensagem.value = "Selecione um dedo para começar o processo";
  biometria.value = false;
  base64Images.value = [];
  loading.value = false;
  if (props.tipoBiometria == "verificacao") {
    mensagem.value = "Clique em Coletar Biometria para iniciar verificação.";
  }
};

const receberDedo = (dedo) => {
  dedoSelecionado.value = dedo;
  mensagem.value = `Posicione o ${dedo.label} no leitor e aguarde`;
  coletarBiometria();
};

const validarVersao = (version) => {
  return versaoRegex.test(version);
};

watch(
  () => props.modal,
  () => {
    valor.value = true;
    getVersion();
    removerDedo.value++;
    biometria.value = false;
    base64Images.value = [];
    negativePrint.value = "";
    loading.value = false;
    getVersion();
    if (props.tipoBiometria == "verificacao") {
      mensagem.value =
        "Clique em Coletar Biometria para iniciar o processo e coloque o dedo no leitor para realizar a coleta.";
      return;
    }
    mensagem.value = "Selecione um dedo para começar o processo";
  }
);
</script>

<style scoped>
#image {
  height: 300px;
  width: 200px;
}
.alinhamento {
  text-align: center;
}
a {
  text-decoration: none;
}
</style>
